import { render, staticRenderFns } from "./ColorManipulation.vue?vue&type=template&id=b95ca178&scoped=true&"
import script from "./ColorManipulation.vue?vue&type=script&lang=js&"
export * from "./ColorManipulation.vue?vue&type=script&lang=js&"
import style0 from "./ColorManipulation.vue?vue&type=style&index=0&id=b95ca178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95ca178",
  null
  
)

export default component.exports